__webpack_require__.p = "/mcducks-digital-treasury/";